import ModalsLib from '../../../../lib/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/daily/tripple_deposit';
import Diamond from '../diamond';

export default () => {
    const {task} = useSelector(Selector);

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/tripple_deposit.png`} alt="Tripple Icon" />
                </div>
                <div className="title">Make 3 Deposits</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Make a three deposits from $20 to get diamonds.
                </div>
                {(task.completed || task.redeemed) ? (
                    <div className="button-block completed">
                        Completed
                    </div>
                ) : (
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            ModalsLib.open('wallet');
                        }}>
                            Deposit
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}